module.exports = __webpack_public_path__ + "img/smartphone-electronic-plates2.dce322d8.jpg";